import { PaymentMethod } from "@orderna/admin-panel/src/app/model/enum/payment-method";
import { FilterOptionItem } from "@orderna/admin-panel/src/types/filter";

export const PAYMENT_TYPE_OPTIONS: FilterOptionItem<PaymentMethod>[] = [
  {
    label: 'GCash',
    value: PaymentMethod.GCASH,
  },
]